import { NurseInclusionPatientCreationInfo } from "@/uiKit/organisms/PatientCreationAndRenewal/NurseInclusion/NurseInclusionPatientCreationInfo.ts";
import { WizardAction, WizardState, wizardUtils } from "@/utils/wizardUtils.ts";

export type InfoStep = {
  step: "Info";
  data: NurseInclusionPatientCreationInfo & {
    prescription: Blob;
  };
};

export type PrescriptionSigningStep = {
  step: "PrescriptionSign";
  data: undefined;
};

export type NurseInclusionPatientCreationSteps = [InfoStep, PrescriptionSigningStep];
export type NurseInclusionPatientCreationState = WizardState<NurseInclusionPatientCreationSteps>;
export type NurseInclusionPatientCreationAction = WizardAction<NurseInclusionPatientCreationSteps>;
export const nurseInclusionPatientCreationWizard = wizardUtils<NurseInclusionPatientCreationSteps>([
  "Info",
  "PrescriptionSign",
]);
